import { render, staticRenderFns } from "./QuizImageSelectForm.vue?vue&type=template&id=24d7d6e0&"
import script from "./QuizImageSelectForm.vue?vue&type=script&lang=ts&"
export * from "./QuizImageSelectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports